import { css } from "styled-components";

export const buttonShadow = css`
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
`;
